import { CommonWebService } from '../../services';
import { AppThunk } from '../../controllers/store';
import config from '../../configuration';
export const EVENTS_ENTRIES_LOADED = 'EVENTS_ENTRIES_LOADED';
export const EVENTS_ENTRIES_LOADING = 'EVENTS_ENTRIES_LOADING';

// export const load = (site: string): AppThunk<Promise<void>> => {
//   return async (dispatch): Promise<void> => {
//     dispatch({ type: EVENTS_ENTRIES_LOADING });
//     const { runMode } = config;
//     const app = runMode === 'kvg' ? 'mykverneland' : 'myvicon';

//     const commonWebService = new CommonWebService();

//     const entries = await commonWebService.getSection(`${app}-events`, site);
//     dispatch({ type: EVENTS_ENTRIES_LOADED, entries });
//   };
// };
